module.exports = __webpack_public_path__ + "static/media/IMG_8118.c4d3d7d6.JPG";